import FusionIcon from '../assets/icons/fusion.svg'
import EthereumIcon from '../assets/icons/eth.svg'
import ICPIcon from '../assets/icons/icp.svg'
import BitcoinIcon from '../assets/icons/btc.svg'
import SolanaIcon from '../assets/icons/sol.svg'
import OdinIcon from '../assets/icons/odin.svg'
import ArbitrumIcon from '../assets/icons/arbitrum.svg'
import BaseIcon from '../assets/icons/base.svg'

const CHAIN_ICONS = {
  all: FusionIcon,
  icp: ICPIcon,
  eth: EthereumIcon,
  btc: BitcoinIcon,
  sol: SolanaIcon,
  odin: OdinIcon,
  arb: ArbitrumIcon,
  base: BaseIcon,
}

export const getChainIcon = (chain: string) => {
  const formattedChain = chain.toLowerCase()
  if (formattedChain in CHAIN_ICONS) {
    return CHAIN_ICONS[formattedChain as keyof typeof CHAIN_ICONS]
  }

  return CHAIN_ICONS.icp
}
